import React from 'react'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

const PhoneNumberUI = ({name, value, onChange, required, autoFocus, disabled, error}) =>
  <PhoneInput
    international
    value={value}
    onChange={onChange}
    disabled={disabled}
    autoComplete='off'
    limitMaxLength={true}
    defaultCountry={'IN'}
    countryCallingCodeEditable={false}
    name={name}
    autoFocus={true}
  />

export default PhoneNumberUI
